import { ContentfulVariant } from "../../../../../types"
import blackDial from "../../../../../images/sections/products/moment/dials/black.png"
import greyDial from "../../../../../images/sections/products/moment/dials/grey.png"
import whiteDial from "../../../../../images/sections/products/moment/dials/white.png"
import whiteNrDial from "../../../../../images/sections/products/moment/dials/white-nr.png"
import beigeNrDial from "../../../../../images/sections/products/moment/dials/beige-nr.png"
import greyDesserto from "../../../../../images/sections/products/moment/straps/grey-desserto.png"
import naturalCork from "../../../../../images/sections/products/moment/straps/natural-cork.png"
import gravelBananatex from "../../../../../images/sections/products/moment/straps/gravel-bananatex.png"
import blackBananatex from "../../../../../images/sections/products/moment/straps/black-bananatex.png"
import blackCork from "../../../../../images/sections/products/moment/straps/black-cork.png"
import blackDesserto from "../../../../../images/sections/products/moment/straps/black-desserto.png"
import dessertoSand from "../../../../../images/sections/products/moment/straps/desserto-sand.png"
import blackGrayDesserto from "../../../../../images/sections/products/moment/watches/black/black-grey-desserto.jpg"
import blackBlackBananatex from "../../../../../images/sections/products/moment/watches/black/black-black-bananatex.png"
import blackBlackCork from "../../../../../images/sections/products/moment/watches/black/black-black-cork.png"
import blackBlackDesserto from "../../../../../images/sections/products/moment/watches/black/black-black-desserto.png"
import blackGravelBananatex from "../../../../../images/sections/products/moment/watches/black/black-gravel-bananatex.png"
import blackNaturalCork from "../../../../../images/sections/products/moment/watches/black/black-natural-cork.png"
import blackDessertoSand from "../../../../../images/sections/products/moment/watches/black/black-desserto-sand.jpg"
import greyGravelBananatex from "../../../../../images/sections/products/moment/watches/grey/grey-gravel-bananatex.png"
import greyGrayDesserto from "../../../../../images/sections/products/moment/watches/grey/grey-grey-desserto.jpg"
import greyBlackBananatex from "../../../../../images/sections/products/moment/watches/grey/grey-black-bananatex.png"
import greyBlackCork from "../../../../../images/sections/products/moment/watches/grey/grey-black-cork.png"
import greyBlackDesserto from "../../../../../images/sections/products/moment/watches/grey/grey-black-desserto.png"
import greyNaturalCork from "../../../../../images/sections/products/moment/watches/grey/grey-natural-cork.png"
import greyDessertoSand from "../../../../../images/sections/products/moment/watches/grey/grey-desserto-sand.jpg"
import whiteNaturalCork from "../../../../../images/sections/products/moment/watches/white/white-natural-cork.png"
import whiteGravelBananatex from "../../../../../images/sections/products/moment/watches/white/white-gravel-bananatex.png"
import whiteGrayDesserto from "../../../../../images/sections/products/moment/watches/white/white-grey-desserto.jpg"
import whiteBlackBananatex from "../../../../../images/sections/products/moment/watches/white/white-black-bananatex.png"
import whiteBlackCork from "../../../../../images/sections/products/moment/watches/white/white-black-cork.png"
import whiteBlackDesserto from "../../../../../images/sections/products/moment/watches/white/white-black-desserto.png"
import whiteDessertoSand from "../../../../../images/sections/products/moment/watches/white/white-desserto-sand.jpg"
import whiteNrNaturalCork from "../../../../../images/sections/products/moment/watches/white-nr/white-nr-natural-cork.png"
import whiteNrGravelBananatex from "../../../../../images/sections/products/moment/watches/white-nr/white-nr-gravel-bananatex.png"
import whiteNrGrayDesserto from "../../../../../images/sections/products/moment/watches/white-nr/white-nr-grey-desserto.jpg"
import whiteNrBlackBananatex from "../../../../../images/sections/products/moment/watches/white-nr/white-nr-black-bananatex.png"
import whiteNrBlackCork from "../../../../../images/sections/products/moment/watches/white-nr/white-nr-black-cork.png"
import whiteNrBlackDesserto from "../../../../../images/sections/products/moment/watches/white-nr/white-nr-black-desserto.png"
import whiteNrDessertoSand from "../../../../../images/sections/products/moment/watches/white-nr/white-nr-desserto-sand.jpg"
import beigeNrNaturalCork from "../../../../../images/sections/products/moment/watches/beige-nr/beige-nr-natural-cork.jpg"
import beigeNrGravelBananatex from "../../../../../images/sections/products/moment/watches/beige-nr/beige-nr-gravel-bananatex.png"
import beigeNrGrayDesserto from "../../../../../images/sections/products/moment/watches/beige-nr/beige-nr-grey-desserto.jpg"
import beigeNrBlackBananatex from "../../../../../images/sections/products/moment/watches/beige-nr/beige-nr-black-bananatex.png"
import beigeNrBlackCork from "../../../../../images/sections/products/moment/watches/beige-nr/beige-nr-black-cork.png"
import beigeNrBlackDesserto from "../../../../../images/sections/products/moment/watches/beige-nr/beige-nr-black-desserto.png"
import beigeNrDessertoSand from "../../../../../images/sections/products/moment/watches/beige-nr/beige-nr-desserto-sand.jpg"

export interface MuditaMomentVariant extends ContentfulVariant {
  image?: string
}

enum Strap {
  NaturalCork = "Natural Cork",
  BlackCork = "Black Cork",
  GrayDesserto = "Gray",
  BlackDesserto = "Black",
  GravelBananatex = "Gravel Bananatex® Gray",
  BlackBananatex = "Gravel Bananatex® Black",
  DessertoSand = "Beige Sand",
}

enum Dial {
  White = "White",
  Black = "Black",
  Gray = "Gray",
  WhiteNR = "White NR",
  BeigeNR = "Beige NR",
}

export const recommendedWatches = [
  "White Dial with Natural Cork Strap",
  "Black Dial with Black Strap",
  "Gray Dial with Gray Strap",
  "White NR Dial with Natural Cork Strap",
  "Beige NR Dial with Beige Sand Strap",
]

export const stripeColors = [
  {
    colorHex: "#585654",
    colorName: Strap.NaturalCork,
    image: naturalCork,
    sku: "678",
    name: Strap.NaturalCork,
  },
  {
    colorHex: "#676363",
    colorName: Strap.BlackCork,
    image: blackCork,
    sku: "567",
    name: Strap.BlackCork,
  },
  {
    colorHex: "#E9E9E9",
    colorName: Strap.GrayDesserto,
    image: greyDesserto,
    sku: "123",
    name: Strap.GrayDesserto,
  },
  {
    colorHex: "#DCDBDB",
    colorName: Strap.BlackDesserto,
    image: blackDesserto,
    sku: "234",
    name: Strap.BlackDesserto,
  },
  {
    colorHex: "#8C8686",
    colorName: Strap.GravelBananatex,
    image: gravelBananatex,
    sku: "456",
    name: Strap.GravelBananatex,
  },
  {
    colorHex: "#A09E9E",
    colorName: Strap.BlackBananatex,
    image: blackBananatex,
    sku: "345",
    name: Strap.BlackBananatex,
  },
  {
    colorHex: "#A09E9E",
    colorName: Strap.DessertoSand,
    image: dessertoSand,
    sku: "789",
    name: Strap.DessertoSand,
  },
] as MuditaMomentVariant[]

export const dialColors = [
  {
    colorHex: "#ffffff",
    colorName: Dial.White,
    image: whiteDial,
    sku: "def",
    name: Dial.White,
  },
  {
    colorHex: "#e5e5e5",
    colorName: Dial.Gray,
    image: greyDial,
    sku: "ghi",
    name: Dial.Gray,
  },
  {
    colorHex: "#626262",
    colorName: Dial.Black,
    image: blackDial,
    sku: "abc",
    name: Dial.Black,
  },
  {
    colorHex: "#626262",
    colorName: Dial.WhiteNR,
    image: whiteNrDial,
    sku: "jkl",
    name: Dial.WhiteNR,
  },
  {
    colorHex: "#626262",
    colorName: Dial.BeigeNR,
    image: beigeNrDial,
    sku: "mno",
    name: Dial.BeigeNR,
  },
] as MuditaMomentVariant[]

export type Watch = Record<string, string>

export const watchImages: Watch = {
  "Black Gray": blackGrayDesserto,
  "Black Gravel Bananatex® Black": blackBlackBananatex,
  "Black Black Cork": blackBlackCork,
  "Black Black": blackBlackDesserto,
  "Black Gravel Bananatex® Gray": blackGravelBananatex,
  "Black Natural Cork": blackNaturalCork,
  "Black Beige Sand": blackDessertoSand,
  "Gray Gray": greyGrayDesserto,
  "Gray Gravel Bananatex® Black": greyBlackBananatex,
  "Gray Black Cork": greyBlackCork,
  "Gray Black": greyBlackDesserto,
  "Gray Gravel Bananatex® Gray": greyGravelBananatex,
  "Gray Natural Cork": greyNaturalCork,
  "Gray Beige Sand": greyDessertoSand,
  "White Gray": whiteGrayDesserto,
  "White Gravel Bananatex® Black": whiteBlackBananatex,
  "White Black Cork": whiteBlackCork,
  "White Black": whiteBlackDesserto,
  "White Gravel Bananatex® Gray": whiteGravelBananatex,
  "White Natural Cork": whiteNaturalCork,
  "White Beige Sand": whiteDessertoSand,
  "White NR Gray": whiteNrGrayDesserto,
  "White NR Gravel Bananatex® Black": whiteNrBlackBananatex,
  "White NR Black Cork": whiteNrBlackCork,
  "White NR Black": whiteNrBlackDesserto,
  "White NR Gravel Bananatex® Gray": whiteNrGravelBananatex,
  "White NR Natural Cork": whiteNrNaturalCork,
  "White NR Beige Sand": whiteNrDessertoSand,
  "Beige NR Gray": beigeNrGrayDesserto,
  "Beige NR Gravel Bananatex® Black": beigeNrBlackBananatex,
  "Beige NR Black Cork": beigeNrBlackCork,
  "Beige NR Black": beigeNrBlackDesserto,
  "Beige NR Gravel Bananatex® Gray": beigeNrGravelBananatex,
  "Beige NR Natural Cork": beigeNrNaturalCork,
  "Beige NR Beige Sand": beigeNrDessertoSand,
}
